import { render, staticRenderFns } from "./TermsTransaction.vue?vue&type=template&id=e87768f2&scoped=true"
import script from "./TermsTransaction.vue?vue&type=script&lang=js"
export * from "./TermsTransaction.vue?vue&type=script&lang=js"
import style0 from "./TermsTransaction.vue?vue&type=style&index=0&id=e87768f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e87768f2",
  null
  
)

export default component.exports